import BaseAxios from 'axios'

const hasApiUrl = (process.env.REACT_APP_API_ENDPOINT?.length || 0) > 0

const baseURL = hasApiUrl ? process.env.REACT_APP_API_ENDPOINT : `${window.location.origin}/api`

const axios = BaseAxios.create({
  baseURL,
  timeout: 300000,
})

const axiosRaw = BaseAxios.create({
  timeout: 300000,
})

export default axios
export {axiosRaw}
